/* eslint-disable camelcase */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_add_classes_to_your_library_and_calendar_create_playlists_set_and_reach_goals_and_more: Phrase =
  locale => {
    const en = `Add classes to your library and calendar, create playlists, set and reach goals, and design a daily yoga routine that aligns with your needs.`;
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `Añade clases a tu biblioteca y calendario, crea listas de reproducción, establece y alcanza objetivos y mucho más.`,
    };
    return phrases[locale] || en;
  };
